import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse, createParamString } from 'data_sources/constants';
import { Role } from 'views/App/Portal/LexID/Roles/_types/role';

export type GroupRolesResponse = {
  roles: Role[];
};

export default function useGroupRoles(
  organizationId: string,
  groupId: string,
  params = {},
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexid/user-group/v1/organizations/${organizationId}/groups/${groupId}/roles`;
  return useQuery<GroupRolesResponse, ServerErrorResponse>(
    ['group_roles', organizationId, groupId, params],
    async ({ signal }): Promise<GroupRolesResponse> => {
      try {
        const paramString = createParamString(params);
        const data: GroupRolesResponse = await fetcher({
          url: `${url}?${paramString}`,
          options: { signal },
        });

        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      keepPreviousData: true,
      ...options,
    }
  );
}
